module.exports = __webpack_public_path__ + "img/python.422216ec.png";